const contentful = require('contentful')
import { environmentVariables, isProductionEnvironment } from 'services/shared/Environment'

let client = null

try {
    client = contentful.createClient({
      accessToken: environmentVariables().CONTENTFUL_ACCESS_TOKEN,
      space: environmentVariables().CONTENTFUL_SPACE_ID,
      environment: isProductionEnvironment() ? "master" : "staging"
    });
} catch(error) {}

export default client